import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { startSSOLogin } from '../lib/oauth.js';

// SSO-only login shell (ported from chat-portal). Auto-redirects to
// auth.teliance.com on mount unless ?manual=1 / ?error= (the post-logout
// and failure landing — avoids an infinite redirect loop).
export default function Login() {
  const location = useLocation();
  const [error, setError] = useState('');
  const [redirecting, setRedirecting] = useState(false);
  const triggeredRef = useRef(false);
  const from = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (triggeredRef.current) return;
    const params = new URLSearchParams(location.search);
    if (params.get('manual') === '1' || params.get('error')) {
      if (params.get('error')) setError(params.get('error'));
      return;
    }
    triggeredRef.current = true;
    setRedirecting(true);
    startSSOLogin(from).catch((err) => {
      setRedirecting(false);
      setError(err?.message || 'Failed to start single sign-on');
    });
  }, [from, location.search]);

  const handleSignIn = async () => {
    setError(''); setRedirecting(true);
    try { await startSSOLogin(from); }
    catch (err) { setRedirecting(false); setError(err?.message || 'Failed to start single sign-on'); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-4">
      <div className="w-full max-w-md border border-border rounded-lg p-8 text-center space-y-4">
        <div className="font-semibold text-xl">Teliance Events</div>
        <div className="text-sm text-muted-foreground">Single sign-on via Teliance auth</div>
        {error && (
          <div className="text-sm text-destructive border border-destructive/40 bg-destructive/5 rounded-md px-3 py-2">{error}</div>
        )}
        <button
          onClick={handleSignIn}
          disabled={redirecting}
          className="w-full px-4 py-2 rounded-md bg-primary text-primary-foreground disabled:opacity-50"
        >
          {redirecting ? 'Redirecting…' : 'Sign in'}
        </button>
      </div>
    </div>
  );
}
